(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/detect/assets/javascripts/detect.js') >= 0) return;  svs.modules.push('/components/core/detect/assets/javascripts/detect.js'); 
var svs = svs || {};

(function($, svs, Modernizr) {
  'use strict';

  svs.core = svs.core || {};
  var isServer =
    typeof process !== 'undefined' &&
    process.release.name.search(/node|io.js/) !== -1; 

  svs.core.Detect = function() {
    var self = {},
      _isPortraitOrientation = true,
      _previousWidth = 0,
      _currentBreakPoint = 'xs',
      _breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'],
      _previousDimensions = {
        offsetTop: 0
      },
      _isPortraitPrevious = true;

    var feature = function(featureName) {
      var features = svs.core.data.features;

      return features && features.indexOf(featureName) > -1;
    };

    var tenant = function(tenant) {
      return svs.core.data.tenant === tenant;
    };

    var formfactor = {
      mobile: function() {
        return (
          svs.core.data.capabilities.formFactor &&
          svs.core.data.capabilities.formFactor === 'mobile'
        );
      },
      desktop: function() {
        return (
          svs.core.data.capabilities.formFactor &&
          svs.core.data.capabilities.formFactor === 'desktop'
        );
      }
    };

    var os = {
      iOS: function() {
        return (
          svs.core.data.capabilities.os &&
          (
            svs.core.data.capabilities.os === 'iphone os' ||
            svs.core.data.capabilities.os === 'os x' && touch()
          )
        );
      },
      windowsPhone: function() {
        return (
          svs.core.data.capabilities.os &&
          svs.core.data.capabilities.os === 'windows phone'
        );
      },
      android: function() {
        return (
          svs.core.data.capabilities.os &&
          svs.core.data.capabilities.os === 'android'
        );
      },
      windows: function() {
        return (
          svs.core.data.capabilities.os &&
          svs.core.data.capabilities.os === 'windows'
        );
      },
      osX: function() {
        return (
          svs.core.data.capabilities.os &&
          svs.core.data.capabilities.os === 'os x' &&
          !touch()
        );
      }
    };

    var browser = {
      chrome: function() {
        return (
          svs.core.data.capabilities.browser &&
          svs.core.data.capabilities.browser === 'chrome'
        );
      },
      android: function() {
        return (
          svs.core.data.capabilities.browser &&
          svs.core.data.capabilities.browser === 'android'
        );
      },
      safari: function() {
        return (
          svs.core.data.capabilities.browser &&
          svs.core.data.capabilities.browser === 'safari'
        );
      },
      firefox: function() {
        return (
          svs.core.data.capabilities.browser &&
          svs.core.data.capabilities.browser === 'firefox'
        );
      },
      msie: function() {
        return (
          svs.core.data.capabilities.browser &&
          svs.core.data.capabilities.browser === 'msie'
        );
      },
      opera: function() {
        return (
          svs.core.data.capabilities.browser &&
          svs.core.data.capabilities.browser === 'opera'
        );
      },
      crios: function() {
        return (
          svs.core.data.capabilities.browser &&
          svs.core.data.capabilities.browser === 'crios'
        );
      },
      ie: function() {
        return (
          svs.core.data.capabilities.browser &&
          svs.core.data.capabilities.browser === 'trident'
        );
      }
    };

    var viewport = {
      width: function() {
        return $(window).width();
      },
      height: function() {
        return $(window).height();
      }
    };

    var touch = function() {
      return Boolean('ontouchstart' in window ||
        window.DocumentTouch && document instanceof DocumentTouch);
    };

    var screen = {
      retina: function() {
        return Modernizr.mq(
          'only screen and (-moz-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)'
        );
      },

      small: function() {
        return Modernizr.mq('only screen and (max-width: 320px)');
      },

      medium: function() {
        return Modernizr.mq(
          'only screen and (min-width: 321px) and (max-width: 640px)'
        );
      },

      large: function() {
        return Modernizr.mq('only screen and (min-width: 641px)');
      }
    };

    var isPortraitOrientation = function() {
      return _isPortraitOrientation;
    };

    var isLandscapeOrientation = function() {
      return !_isPortraitOrientation;
    };

    var checkWindowSize = function() {
      var $body = $('body'),
        $window = $(window),
        height = $window.outerHeight(),
        width = $window.outerWidth(),
        hasOrientationChanged = false,
        ratio = '14/9'; 

      if (_previousWidth === 0) {
        _isPortraitOrientation = os.iOS()
          ? height > width
          : window.matchMedia('(max-aspect-ratio:14/9)').matches;
        if (_isPortraitOrientation) {
          $body.addClass('orientation-portrait');
        } else {
          $body.addClass('orientation-landscape');
        }
      } else {
        hasOrientationChanged =
          _previousWidth !== width ||
          _isPortraitPrevious !== _isPortraitOrientation;
        if (hasOrientationChanged) {
          if (
            os.iOS() && !_isPortraitOrientation ||
            !os.iOS() &&
              window.matchMedia('(max-aspect-ratio:' + ratio + ')').matches
          ) {
            _isPortraitOrientation = true;
          } else if (
            os.iOS() && _isPortraitOrientation ||
            !os.iOS() &&
              window.matchMedia('(min-aspect-ratio:' + ratio + ')').matches
          ) {
            _isPortraitOrientation = false;
          } else {
            hasOrientationChanged = false;
          }
        }
      }

      _previousWidth = width;
      _isPortraitPrevious = _isPortraitOrientation;

      if (hasOrientationChanged) {
        $body
          .removeClass('orientation-landscape')
          .removeClass('orientation-portrait');

        if (_isPortraitOrientation) {
          $body.addClass('orientation-portrait');
        } else {
          $body.addClass('orientation-landscape');
        }
        if (self.orientation) {
          self.orientation.trigger('change');
        }

        $body
          .removeClass('orientation-landscape')
          .removeClass('orientation-portrait');

        if (_isPortraitOrientation) {
          $body.addClass('orientation-portrait');
        } else {
          $body.addClass('orientation-landscape');
        }
      }
    };

    var checkCurrentBreakpoint = function() {
      var getCurrentBreakpoint = window
          .getComputedStyle(document.querySelector('body'), ':before')
          .getPropertyValue('content')
          .replace(/"/g, ''),
        tmpBreakpoint = _currentBreakPoint;

      _currentBreakPoint = getCurrentBreakpoint;
      if (tmpBreakpoint !== getCurrentBreakpoint) {
        self.breakpoint.current = getCurrentBreakpoint;
        self.breakpoint.was = tmpBreakpoint;
        checkDimensions();
        self.breakpoint.trigger('change', {
          current: getCurrentBreakpoint,
          was: tmpBreakpoint
        });
      }
    };

    var getCurrentBreapointIndex = function() {
      var index;
      _breakpoints.forEach(function(_bp, i) {
        if (_currentBreakPoint === _bp) {
          index = i;
        }
      });
      return index;
    };

    var checkCurrentBreakpointLessThan = function(bp) {
      var lessThan = false;
      _breakpoints.forEach(function(_bp, i) {
        if (bp === _bp) {
          if (getCurrentBreapointIndex(bp) < i) {
            lessThan = true;
          }
        }
      });
      return lessThan;
    };

    var checkCurrentBreakpointGreaterThan = function(bp) {
      var greaterThan = false;
      _breakpoints.forEach(function(_bp, i) {
        if (bp === _bp) {
          if (getCurrentBreapointIndex(bp) > i) {
            greaterThan = true;
          }
        }
      });
      return greaterThan;
    };

    var checkCurrentBreakpointEquals = function(bp) {
      var equals = false;
      _breakpoints.forEach(function(_bp, i) {
        if (bp === _bp) {
          if (getCurrentBreapointIndex(bp) === i) {
            equals = true;
          }
        }
      });
      return equals;
    };

    var checkDimensions = function() {
      if (self.breakpoint.current !== self.breakpoint.was) {
        var $header = document.querySelector('header');
        if ($header && $header.offsetHeight) {
          var offsetTop = $header.offsetHeight + $header.offsetTop,
            availiableHeight = window.innerHeight - offsetTop,
            dimensions = {
              offsetTop: offsetTop,
              availiableHeight: availiableHeight
            };

          if (dimensions.offsetTop !== _previousDimensions.offsetTop) {
            $.extend(self.dimensions, dimensions);
            self.dimensions.trigger('change', dimensions);
            _previousDimensions = dimensions;
          }
        }
      }
    };

    self = {
      feature: feature,
      tenant: tenant,
      formfactor: formfactor,
      os: os,
      browser: browser,
      viewport: viewport,
      touch: touch,
      screen: screen,
      isServer: isServer,
      isBrowser: !isServer
    };

    if (!isServer) {
      self.orientation = new svs.core.Events({
        isPortrait: isPortraitOrientation,
        isLandscape: isLandscapeOrientation
      });
      self.breakpoint = new svs.core.Events({
        current: _currentBreakPoint,
        was: false,
        lessThan: function(size) {
          return checkCurrentBreakpointLessThan(size);
        },
        greaterThan: function(size) {
          return checkCurrentBreakpointGreaterThan(size);
        },
        equals: function(size) {
          return checkCurrentBreakpointEquals(size);
        }
      });
      self.dimensions = new svs.core.Events(_previousDimensions);

      if (os.android() || os.iOS()) {
        window.addEventListener(
          'resize',
          function(e) {
            checkWindowSize(e);
          },
          false
        );
        checkWindowSize();
      } else if (os.windowsPhone()) {
        window.addEventListener(
          'resize',
          function(e) {
            setTimeout(function() {
              checkWindowSize(e);
            }, 60);
          },
          false
        );
        checkWindowSize();
      }
      var resizeTimer;
      window.addEventListener(
        'resize',
        function() {
          resizeTimer = setTimeout(function() {
            checkCurrentBreakpoint();
            clearTimeout(resizeTimer);
          }, 10);
        },
        false
      );
      checkCurrentBreakpoint();
      checkDimensions();
    }

    if (typeof window !== 'undefined') {
      window.svs = window.svs || {};
      window.svs.isServer = self.isServer;
      window.svs.isBrowser = self.isBrowser;
    }
    if (typeof global !== 'undefined') {
      global.svs = global.svs || {};
      global.svs.isServer = self.isServer;
      global.svs.isBrowser = self.isBrowser;
    }

    return self;
  };

  svs.core.detect = new svs.core.Detect();

  if (isServer) {
    module.exports = {
      feature: svs.core.detect.feature,
      tenant: svs.core.detect.tenant
    };
  }
})(
  typeof exports === 'object' ? null : jQuery,
  svs,
  typeof exports === 'object' ? null : Modernizr
);

 })(window);